export default function initCouponDialog() {
  Alpine.data('couponDialog', (error = '', requiredError = '') => ({
    showCoupon: error !== '',
    error,
    requiredError,
    invalid: error !== '',
    toggle() {
      this.showCoupon = !this.showCoupon;
      if (this.showCoupon) {
        document.getElementById('cart-sidebar')?.classList.remove('lg:sticky');
      }
    },
    onSubmit(event: Event) {
      const couponCode = document.getElementById('coupon-code-input') as HTMLInputElement;
      if (couponCode && couponCode.value.trim() === '') {
        event.preventDefault();
        this.error = this.requiredError;
        this.invalid = true;
      }
    },
    init() {
      this.$watch('showCoupon', (value, oldValue) => {
        if (!value && value !== oldValue) {
          document.getElementById('cart-sidebar')?.classList.add('lg:sticky');
          this.error = '';
          this.invalid = false;
        }
      });
    },
  }));
}
